"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidReferralCode = exports.trimObjects = exports.isDateValid = exports.isDobValid = exports.toIsoString = exports.aphClientDateFormat = exports.isNameValid = exports.isMobileNumberValid = exports.isEmailValid = void 0;
var isMobilePhone_1 = __importDefault(require("validator/lib/isMobilePhone"));
var isEmail_1 = __importDefault(require("validator/lib/isEmail"));
exports.isEmailValid = isEmail_1.default;
exports.isMobileNumberValid = function (number) {
  return isMobilePhone_1.default(number, "en-IN");
};
exports.isNameValid = function (name) {
  var passesEmpty = name.length >= 1;
  var passesApostropheConditions =
    !name.startsWith("'") && !name.endsWith("'") && !name.includes("''");
  return (
    /^[a-zA-Z ']*$/.test(name.trim()) &&
    name.trim().length >= 1 &&
    passesApostropheConditions &&
    passesEmpty
  );
};
exports.aphClientDateFormat = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
exports.toIsoString = function (ddmmyyyy) {
  var dateParts = ddmmyyyy.split("/");
  var dd = dateParts[0];
  var mm = dateParts[1];
  var yyyy = dateParts[2];
  return yyyy + "-" + mm + "-" + dd;
};
exports.isDobValid = function (ddmmyyyy) {
  if (!exports.isDateValid(ddmmyyyy)) return false;
  var isoStr = exports.toIsoString(ddmmyyyy);
  var date = new Date(isoStr);
  var isInPast = new Date() > date;
  return isInPast;
};
exports.isDateValid = function (ddmmyyyy) {
  var isCorrectFormat = exports.aphClientDateFormat.test(ddmmyyyy);
  if (!isCorrectFormat) return false;
  var dateParts = ddmmyyyy.split("/");
  var dd = dateParts[0];
  var mm = dateParts[1];
  var yyyy = dateParts[2];
  var dateStr = yyyy + "-" + mm + "-" + dd;
  var isValidJsDate = !isNaN(new Date(dateStr).valueOf());
  // https://stackoverflow.com/questions/12756159/regex-and-iso8601-formatted-datetime
  var isValidCalendarDate = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(
    ddmmyyyy
  );
  return isValidJsDate && isValidCalendarDate;
};
exports.trimObjects = function (jsonObject) {
  if (Object.keys.length) return jsonObject;
  return JSON.parse(JSON.stringify(jsonObject).replace(/"\s+|\s+"/g, '"'));
};
exports.isValidReferralCode = function (referralCode) {
  return referralCode.length <= 25;
};
//# sourceMappingURL=aphValidators.js.map
